"use client";

import Link from "next/link";
import { FaWhatsapp } from "react-icons/fa";

import { WHATSAPP_LINK } from "@/constants/links";
import { logEvent } from "@/services/firebase";

export const FloatingWhatsapp = () => {
  return (
    <Link
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 bg-green-500 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg hover:bg-green-500/90 transition duration-300"
      aria-label="Fale conosco pelo WhatsApp"
      onClick={() =>
        logEvent("agendar_consulta_click", { section: "floating-whatsapp" })
      }
    >
      <FaWhatsapp size={32} aria-hidden="true" />
    </Link>
  );
};
